import { ComponentProps, FC } from 'react'
import { addDisplayName, addHandlers, flowMax } from 'ad-hok'
import { addNavigate } from 'shared/src/utils/addNavigate'

import backButtonIconDark from 'assets/back-button.svg'
import backButtonIconLight from 'assets/caret-left.svg'
import { ImageButton } from './ImageButton'
import { ForegroundStyle } from 'utils/styles'

const ICONS: Record<ForegroundStyle, string> = {
  dark: backButtonIconDark,
  light: backButtonIconLight,
}

interface Props
  extends Omit<
    ComponentProps<typeof ImageButton>,
    'onClick' | 'image' | 'width' | 'height'
  > {
  foregroundStyle: ForegroundStyle
}

export const BackButton: FC<Props> = flowMax(
  addDisplayName('BackButton'),
  addNavigate,
  addHandlers({
    onClick:
      ({ navigate }) =>
      () => {
        navigate(-1)
      },
  }),
  ({ onClick, foregroundStyle, ...props }) => (
    <ImageButton
      image={ICONS[foregroundStyle]}
      width={20}
      height={20}
      onClick={onClick}
      {...props}
    />
  )
)
